import Component from '@glimmer/component'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'
import { action } from '@ember/object'
import themeKey from 'teacher-ui-client/helpers/theme-key'
import { Pill, PILL_APPEARANCE } from 'teacher-ui-client/components/base/pill'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { on } from '@ember/modifier'
import { fn } from '@ember/helper'
import { t } from 'ember-intl'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

interface Signature {
  Element: HTMLDivElement
}

export function deserializeFilterPhase(filterPhase: string): number[] {
  return (
    filterPhase
      .split(',')
      .map((n) => Number.parseInt(n, 10))
      .filter((n) => !Number.isNaN(n)) ?? []
  )
}

export function serializeFilterPhase(filterPhase: number[]) {
  return filterPhase.join(',')
}

export class FastPhonicsPhaseFilters extends Component<Signature> {
  @service router!: RouterService

  get selectedPhases() {
    const filterPhase = this.router.currentRoute?.queryParams.filterPhase
    return deserializeFilterPhase(typeof filterPhase === 'string' ? filterPhase : '')
  }

  get phaseFilters() {
    const { selectedPhases } = this
    return [2, 3, 4, 5].map((phase) => {
      return {
        phase,
        selected: selectedPhases.includes(phase),
      }
    })
  }

  @action
  togglePhase(phase: number) {
    const { selectedPhases } = this
    let filterPhase
    if (selectedPhases.includes(phase)) {
      filterPhase = selectedPhases.filter((selectedPhase) => selectedPhase !== phase)
    } else {
      filterPhase = [...selectedPhases, phase]
    }
    void this.router.transitionTo({
      queryParams: { filterPhase: serializeFilterPhase(filterPhase) },
    })
  }
  <template>
    <div class="flex justify-center space-x-2" ...attributes>
      {{#each this.phaseFilters as |phaseFilter|}}
        <Pill
          data-test-phase-filter={{phaseFilter.phase}}
          data-test-phase-filter-selected={{phaseFilter.selected}}
          class="flex items-center px-5 py-2 font-semibold {{unless phaseFilter.selected 'shadow-lg'}}"
          @theme={{themeKey SubscriptionType.Reading}}
          @appearance={{PILL_APPEARANCE.outline}}
          @selected={{phaseFilter.selected}}
          {{on "click" (fn this.togglePhase phaseFilter.phase)}}
        >
          <span>{{t "pages.product.lessons.phaseFilter" phase=phaseFilter.phase}}</span>
          {{#if phaseFilter.selected}}
            <PhosphorIcon @icon="phosphor-x-bold" class="ml-2" />
          {{/if}}
        </Pill>
      {{/each}}
    </div>
  </template>
}
export default FastPhonicsPhaseFilters
